import { c as _c } from "react/compiler-runtime";
import { ChevronRight } from 'lucide-react';
import { Link } from '@/core/i18n/navigation';
import { SmartIcon } from '@/shared/blocks/common';
import { NavItem } from '@/shared/types/blocks/common';
export function Crumb(t0) {
  const $ = _c(4);
  const {
    items
  } = t0;
  let t1;
  if ($[0] !== items) {
    t1 = items.map(_temp);
    $[0] = items;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <nav className="text-muted-foreground flex items-center text-sm md:px-3">{t1}</nav>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
function _temp(item, index) {
  const isActive = item.is_active;
  return <div key={index} className="flex items-center"><Link href={item.url || ""} className={`hover:text-foreground line-clamp-1 flex min-w-8 items-center gap-2 transition-colors ${isActive ? "text-primary hover:text-primary font-medium" : ""}`}>{item.icon && <SmartIcon name={item.icon as string} className="size-4" />}{item.title}</Link>{!isActive && <ChevronRight className="text-muted-foreground/40 mx-2 h-4 w-4" />}</div>;
}